<div class="wrapper">

    <app-header [showFilter]="showFilter"></app-header>

    <div class="content-page">
        <router-outlet></router-outlet>
    </div>
    <app-cookie-message></app-cookie-message>
    <app-footer></app-footer>

</div>
